export const getTextWidth = (text, fontSize = 16) => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  context.font = `${fontSize}px Poppins`;

  const metrics = context.measureText(text);
  return Math.round(metrics.width);
};
